// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xMdi","colBig":"styles_colBig__3Wn_B","colSmall":"styles_colSmall__coLPw"};